module.exports = __webpack_public_path__ + "static/img/05img.11ac28ba.png";